
import { ref } from "vue";
import { Options, mixins } from "vue-class-component";
import StoreReports from "../../service/StoreReports";
import UtilityOptions from "../../mixins/UtilityOptions";
import ProfilerService from "../../service/ProfilerService.js";
import UserService from "../../service/UserService.js";
import AutoComplete from "primevue/autocomplete";
import Toaster from "../../helpers/Toaster";

interface salesReportList {
  branchName:string,
  receiptDate:string,
  receiptNo:string,
  cashierName:string,
  discount:string,
  totalBill:string,
  customerName:string,
  customerNumber:string,
  paymentMethod:string,
  paidAmount:string
  paidDate:string
}

@Options({
  title: 'Sales Report',
  components: {AutoComplete},
  watch: {
    lists: {
      handler(newLists) {
        this.totalSubTotal = newLists.reduce(
          (acc, item) => acc + (parseFloat(item.totalBill) || 0),
          0
        );
        this.totalDiscounts = newLists.reduce(
          (acc, item) => acc + (parseFloat(item.discount) || 0),
          0
        );
        this.totalPayLater = newLists.reduce(
          (acc, item) => acc + ((item.paymentMethod != 'Pay Later')?parseFloat(item.paidAmount):0 || 0),
          0
        );
      },
      immediate: true,
    },
  },
})

export default class SalesReport extends mixins(UtilityOptions) {
  private totalSubTotal = 0;
  private totalDiscounts = 0;
  private totalPayLater = 0;
  private dt = ref();
  private lists: salesReportList[] = [];
  private profilerList = [];
  private userList = [];
  private reportService;
  private profilerService;
  private userService;
  private resultTitle = "";
  private productDialog = false;
  private loading = false;
  private home = { icon: "pi pi-home", to: "/" };
  private items = [
    { label: "Reports", to: "index" },
    { label: "Sales Report", to: "sales-report"  },
  ];
  private limit = 0;
  private totalRecords = 0;
  private goToFirstLink = 0;
  private menuBar = false;
  private previewTransactionDialog = false;
  private toast;

  private searchFilters = {
    filterType:"None",
    date1: "",
    date2: "",
    cashierID: 0,
    branchID: 0,
    paymentMethodID: 0,
  };

  // private selectedRow = {
  //     id:false,
  //     itemList: [],
  //     paymentTransactions: []
  // };

  // private taxNames = [
  //   {
  //     taxName: "",
  //     show: false,
  //     optionalReq: "",
  //     taxValue: 0,
  //     accountHead: "",
  //     accountID: 0,
  //   },
  //   {
  //     taxName: "",
  //     show: false,
  //     optionalReq: "",
  //     taxValue: 0,
  //     accountHead: "",
  //     accountID: 0,
  //   },
  //   {
  //     taxName: "",
  //     show: false,
  //     optionalReq: "",
  //     taxValue: 0,
  //     accountHead: "",
  //     accountID: 0,
  //   },
  // ];

  // private reportTypes = [
  //   {
  //     name: 'Sales',
  //   },
  //   {
  //     name: 'Refund',
  //   },
  // ];

  // private brands:any = [];
  // private sectors:any = [];
  // private categories:any = [];
  // private productTypes:any = [];

  private paymentMethods;
  private cashiers;
  private filterDates = [];
  private dialogTitle;
  private submitted = false;

  data() {
    return {
      lists: [], // Your data
      totalSubTotal: 0, // Total for subTotal column
    }
  }
  
  //CALLING WHEN PAGINATION BUTTON CLICKS
  onPage(event) {
      this.loadList(event.first);
  }

  //CALLING WHENEVER COMPONENT LOADS
  created() {
    this.toast = new Toaster();
    this.reportService = new StoreReports();
    this.profilerService = new ProfilerService();
    this.userService = new UserService();
  }
  
   //CALLNING AFTER CONSTRUCTOR GET CALLED
  mounted() {
    this.loadFilers();
    this.loadList(0);
  }

  //OPEN DIALOG TO ADD NEW ITEM
  openDialog() {       
    this.submitted = false;
    this.dialogTitle = "Filter Report";
    this.productDialog = true;
  }  
  //CLOSE DIALOG
  closeDialog() {
      this.productDialog = false;
  }


  openMenu(data) {
    this.menuBar = true;
    // this.selectedRow.id = data.id;
  }

  loadFilers()
  {
    this.reportService.getFilterList().then((res) => {
      this.filterDates   = res.datesList;
      this.paymentMethods = res.payment_methods;
      this.cashiers = res.cashiers;
      this.cashiers.push({id:0, name:'All'}); 
      this.paymentMethods.push({id:0, name:'All'}); 
    });
  }
 
  // USED TO GET SEARCHED ASSOCIATE
  loadList(page) {
    this.loading = true;
    this.reportService.salesReport(this.searchFilters, page).then((res) => {
        const data = this.camelizeKeys(res);
        this.resultTitle = data.resultTitle;
        this.loading = false;
        this.limit = data.limit;
        this.totalRecords = data.totalRecords;
        this.goToFirstLink = page;

        var tempTrnArray = <any> [];
        data.record.forEach(element => {
          element.payLater.forEach(subElement => {
            var alreadyAdded = false;
            alreadyAdded = tempTrnArray.find(
              (item) => item.receiptNo === element.receiptNo
            );
            
            var myObj = {
              branchName:(!alreadyAdded)?element.branchName:'',
              receiptDate:(!alreadyAdded)?element.receiptDate:'',
              receiptNo:element.receiptNo,
              userName:(!alreadyAdded)?element.userName:'',
              discount:(!alreadyAdded)?element.discount:'',
              totalBill:(!alreadyAdded)?element.totalBill:'',
              customerName:(!alreadyAdded)?element.customerName:'',
              customerNumber:(!alreadyAdded)?element.customerContact:'',
              paymentMethod:'Pay Later',
              paidAmount:subElement.transAmount,
              paidDate:subElement.createdAt
            };
            tempTrnArray.push(myObj);
          });

          element.receiptBalance.forEach(subElement => {
            var alreadyAdded = false;
            alreadyAdded = tempTrnArray.find(
              (item) => item.receiptNo === element.receiptNo
            );
            
            var myObj = {
              branchName:(!alreadyAdded)?element.branchName:'',
              receiptDate:(!alreadyAdded)?element.receiptDate:'',
              receiptNo:element.receiptNo,
              userName:(!alreadyAdded)?element.userName:'',
              discount:(!alreadyAdded)?element.discount:'',
              totalBill:(!alreadyAdded)?element.totalBill:'',
              customerName:(!alreadyAdded)?element.customerName:'',
              customerNumber:(!alreadyAdded)?element.customerContact:'',
              paymentMethod:subElement.paymentType,
              paidAmount:subElement.transAmount,
              paidDate:subElement.createdAt
            };
            tempTrnArray.push(myObj);
          });
        });

        this.lists = tempTrnArray;
        
        this.closeDialog();
      });
    this.productDialog = false;
  }

  // searchProfiler(event) {
  //   setTimeout(() => {
  //     this.profilerService.searchProfiler(event.query.trim()).then((data) => {
  //       this.profilerList = data.records;
  //     });
  //   }, 200);
  // }
  
  // searchUser(event) {
  //   setTimeout(() => {
  //     this.userService.searchUser(event.query.trim()).then((data) => {
  //       this.userList = data.records;
  //     });
  //   }, 200);
  // }

  saveProfile(event) {
    const profileInfo = event.value;
    // this.searchFilters.customerName = profileInfo.account_title;
    // this.searchFilters.customerID = profileInfo.id;
  }
  
  // saveUser(event) {
  //   const userInfo = event.value;
  //   // this.searchFilters.UserName = userInfo.name;
  //   // this.searchFilters.userID = userInfo.id;
  // }

  get currency() {
    return this.store.getters.getCurrency;
  }

  get rList() {
      const l: salesReportList[] = [];

      this.lists.forEach((e) => {
          l.push(e);
      });

      return l;
  }

  exportCSVWithFooter() {
    const dt = this.$refs.dt; // Reference to the DataTable
    const headers = ['Branch', 'Date', 'Receipt No', 'Cashier', 'Discount', 'Total', 'Customer','Customer Number', 'Payment Method', 'Amount'];
    const rows = this.rList.map(item => [
      item.branchName,
      item.receiptDate,
      item.receiptNo,
      item.customerName,
      this.formatAmount(item.discount),
      this.formatAmount(item.totalBill),
      item.customerName,
      item.customerNumber,
      item.paymentMethod,
      this.formatAmount(item.paidAmount),
    ]);
    const footer = [
      'Total', '', '', '', 
      `${this.formatAmount(this.totalDiscounts)}`,
      `${this.formatAmount(this.totalSubTotal)}`,
      '', '', 
      `${this.formatAmount(this.totalPayLater)}`
    ];

    // Combine headers, rows, and footer
    const csvContent = [
      headers.join(','), 
      ...rows.map(row => row.join(',')), 
      footer.join(',')
    ].join('\n');

    // Trigger the download
    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.setAttribute('download', 'sales_report_with_totals.csv');
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
}
